import React, { useState, useEffect } from "react";
import Images from "../../../media/images";
import { fetchBranch } from "../../../features/branch/branchSlice";
import { useDispatch, useSelector } from "react-redux";
import api from "../../../api/api";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { toast } from "react-toastify";
import {useForm} from "react-hook-form"


const TaskCreate = () => {
  const branch = useSelector((state) => state.branch);
  const [staff, setStaff] = useState([]);
  const dispatch = useDispatch();
  const { register, handleSubmit, unregister } = useForm();

  const [searchData, setSearchData] = useState([]);
  const [cmpId, setCmpId] = useState(null)


  useEffect(() => {
    dispatch(fetchBranch());
  }, []);


  // fetch users
  useEffect(() => {
    api
      .get("/users/?user_type=ST")
      .then((response) => {
        // console.log('response',response.data)
        setStaff(response.data);
      })
      .catch((err) => alert("something went wrong"));
  }, []);


  // fetch company
  useEffect(() => {
    api
      .get(`services/company/`)
      .then((response) => {
        // console.log(response.data)
        setSearchData(
          response.data.map(({ company_name: name, id }) => ({ name, id }))
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    // console.log(string, results)
  };

  const handleOnHover = (result) => {
    // the item hovered
    // console.log(result)
  };

  const handleOnSelect = (item) => {
    // the item selected
    // console.log(item)
    api
      .get(`/services/company/${item.id}/`)
      .then((response) => {
        console.log("Result",response.data)
        // setResults(response.data);
        setCmpId(response.data.id)

      })
      .catch((error) => {
        
        toast.error("something went wrong");
      });
  };

  const handleOnFocus = () => {
    // console.log('Focused')
  };


  const handleSub = (data) => {
    console.log('data',data)
    data.company = cmpId

    const user = JSON.parse(localStorage.getItem("user"));
    data.created_by = user.user_id;


    api.post('/tasks/', data)
    .then(respone=> {
      toast.success("Data registered successfully")
    }).catch(error=> {
     
      let response = error.response.data
      var result = Object.keys(error.response.data).map((key) => (`${ key } : ${response[key]}`)  );
      
      result.map((item)=> {
        toast.error(item)
      })
      
      // toast.error("Something went wrong")
    })
  }


  const formatResult = (item) => {
    return (
      <>
        {/* <span style={{ display: 'block', textAlign: 'left' }}>id: {item.id}</span> */}
        <span style={{ display: "block", textAlign: "left" }}>{item.name}</span>
      </>
    );
  };

  return (
    <div>
      <div className="">
        <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
          New Task Create
        </h1>
        <div className="">
          <img src={Images.title_border} alt="" className="mx-auto mt-4" />
        </div>
        {/*   */}
        <form className="mt-10 px-3 pb-10 md:!px-10" onSubmit={handleSubmit(handleSub)}>
          <div className="border">
            <div className="grid grid-cols-1 md:grid-cols-2">
              {/*  date */}
              <div className="border-primary-blue flex flex-wrap items-center gap-2 border-2 p-2">
                <label htmlFor="" className="text-primary-red">
                  Task Create Date:
                </label>
                <input
                  type="date"
                  name=""
                  className="text-primary-blue flex-grow py-2 px-2 outline-none"
                  id="nepali-datepicker"
                  placeholder="Select Nepali Date"
                  {...register('assigned_at', {required: false})}
                
                />
              </div>
              {/* pan no */}
              <div className="border-primary-blue flex flex-wrap items-center gap-2 border-2 border-t-0 p-2 md:!border-t-2 md:border-l-0">
                <label htmlFor="" className="text-primary-red">
                  Branch Name:
                </label>
                <div className="flex-grow items-center gap-2 lg:flex">
                  <select
                    name=""
                    {...register("branch_code", {required : false})}
                    className="border-primary-blue text-primary-blue w-full border p-2"
                  >
                    <option>Select</option>
                    {branch?.data?.map((item, i) => (
                      <option key={i} value={item.code}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {/* staff name */}
              <div className="border-primary-blue flex flex-wrap items-center gap-2 border-2 border-t-0 border-r-0 p-2">
                <label htmlFor="" className="text-primary-red">
                  Staff Name:
                </label>
                <div className="flex-grow items-center gap-2 lg:flex">
                  <select
                    name=""
                    className="border-primary-blue w-full border text-primary-blue p-2"
                    {...register('assigned_to', { required: false })}
                  >
                    <option>Select</option>
                  
                    {staff.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.profile.f_name + 
                        " " + item.profile.l_name} 
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {/* company name */}
              <div className="border-primary-blue flex flex-wrap items-center gap-2 border-2 border-t-0 p-2">
                <label htmlFor="" className="text-primary-red">
                  Company Name:
                </label>
                <div className="flex-grow items-center gap-2 lg:flex">
                  
                  <div className="md:w-100 w-60 text-primary-blue">
                    <ReactSearchAutocomplete
                      items={searchData}
                      onSearch={handleOnSearch}
                      onHover={handleOnHover}
                      onSelect={handleOnSelect}
                      onFocus={handleOnFocus}
                      autoFocus
                      formatResult={formatResult}
                    />
                  </div>
                </div>
              </div>
              {/* details  */}
              <div className="border-primary-blue border-2 border-t-0 p-2 md:col-span-2">
                <label htmlFor="" className="text-primary-red">
                  Task/job Details:
                </label>
                <textarea

                  {...register("job_details", {
                    required: false,
                  })}
                  // name=""
                  id=""
                  cols={30}
                  rows={10}
                  className="w-full p-3 outline-none text-primary-blue"
                  // defaultValue={""}
                />
              </div>
            </div>
          </div>

          {/* save submit btn */}
          <button type="submit" className="bg-primary-green ml-10 mt-5 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
            Save
          </button>
          
        </form>
      </div>
    </div>
  );
};
export default TaskCreate;
